import React, { useContext } from 'react';
import styles from './index.scss';
import BrandLogo from '@xo-union/component-brand-logo';
import BackButton from '../BackButton';
import { FullBleedContainer, TopLevelContainer } from '@xo-union/tk-component-grid';
import { OnboardingContext, STEPS, OnboardingType } from '../../OnboardingContext';

const getBackButtonText = (step: STEPS, onboardingType?: OnboardingType) => {
  if (step !== STEPS.BASIC_INFO) return 'Back';
  if (step === STEPS.BASIC_INFO && onboardingType === 'AI') return 'Back';
  return 'Back to designs';
};
const FullscreenTopbar: React.FC = () => {
  const { step, onboardingType } = useContext(OnboardingContext);
  const buttonText = getBackButtonText(step, onboardingType);

  return (
    <>
      <div className={styles.topBar}>
        <FullBleedContainer>
          <TopLevelContainer>
            <div className={styles.logoHolder}>
              <BrandLogo name="theknot" color="primary" size="lg" />
            </div>
          </TopLevelContainer>
        </FullBleedContainer>
      </div>

      <FullBleedContainer>
        <TopLevelContainer>
          <div className={styles.backButtonHolder}>
            <BackButton buttonText={buttonText} className={styles.backButton} />
          </div>
        </TopLevelContainer>
      </FullBleedContainer>
    </>
  );
};

export default FullscreenTopbar;
